import { createRouter, createWebHistory } from 'vue-router';
import BookingSuccessPage from '../views/BookingSuccessPage.vue';
import MyOffersPage from '../views/MyOffersPage.vue';
import HomePage from '../views/HomePage.vue';
import Cgu from '../views/CGUPage.vue';
import ProfilePage from '../views/ProfilePage.vue';
import LoginPage from '../views/LoginPage.vue';
import ForgotPasswordPage from '../views/ForgottenPasswordPage.vue';
import ResetPasswordPage from '../views/ResetPasswordPage.vue';
import OffersListPage from '../views/OffersListPage.vue';
import OfferDetailsPage from '../views/OfferDetailsPage.vue';
import test from '../views/testPage.vue';
import AccountPage from '../views/AccountPage.vue';
import OfferDetailsPageV2 from '../views/OfferDetailsPageV2.vue';
import ContactPage from '../views/ContactPage.vue';
import GaleryPage from '../views/GalleryPage.vue';
import ImagesGestionPage from '../views/ImagesGestionPage.vue';
import ConfirmationPage from '@/components/ConfirmationPage.vue';
import mentionslegales from '../views/mentions-legalesPage.vue';
import politiqueConfidentialite from '../views/politique-de-confidentialitePage.vue';

const routes = [
  {
    path: '/my-offers',
    name: 'MyOffers',
    component: MyOffersPage,
    meta: {
      title: 'OuiCSport – Activités et séjours sportifs',
      description: 'Trouve et réserve des séjours ou activités sportives en groupe partout en France.'
    }
  },
  {
    path: '/admin-website/administration',
    redirect: '/admin-website/administration/users'
  },
  {
    path: '/test',
    name: 'test',
    component: test,
    meta: {
      title: 'OuiCSport – Activités et séjours sportifs',
      description: 'Trouve et réserve des séjours ou activités sportives en groupe partout en France.'
    }
  },
  {
    path: '/booking-success',
    name: 'BookingSuccess',
    component: BookingSuccessPage,
    meta: {
      title: 'OuiCSport – Activités et séjours sportifs',
      description: 'Trouve et réserve des séjours ou activités sportives en groupe partout en France.'
    }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: ProfilePage,
    meta: {
      title: 'OuiCSport – Activités et séjours sportifs',
      description: 'Trouve et réserve des séjours ou activités sportives en groupe partout en France.'
    }
  },
  {
    path: '/login',
    name: 'LoginPage',
    component: LoginPage,
    meta: {
      title: 'OuiCSport | Connexion ou Inscription',
      description: "Connectez-vous à votre compte OuiCSport ou inscrivez-vous pour participer à nos activités sportives. Rejoignez une communauté dynamique et profitez d’un accès personnalisé à nos offres."
    }
  },
  {
    path: '/AccountPage',
    name: 'AccountPage',
    component: AccountPage,
    meta: {
      title: 'OuiCSport | Mon Compte – Mes Réservations et Informations',
      description: '"Accédez à votre espace personnel OuiCSport pour consulter vos réservations passées et à venir, modifier vos informations, gérer vos crédits et annuler une activité si besoin"'
    }
  },
  {
    path: '/forgot-password',
    name: 'ForgotPasswordPage',
    component: ForgotPasswordPage,
    meta: {
      title: 'OuiCSport – Activités et séjours sportifs',
      description: 'Trouve et réserve des séjours ou activités sportives en groupe partout en France.'
    }
  },
  {
    path: '/reset-password',
    name: 'ResetPasswordPage',
    component: ResetPasswordPage,
    meta: {
      title: 'OuiCSport – Activités et séjours sportifs',
      description: 'Trouve et réserve des séjours ou activités sportives en groupe partout en France.'
    }
  },
  {
    path: '/',
    name: 'HomePage',
    component: HomePage,
    meta: {
      title: 'OuiCSport | Activités et Séjours Sportifs en Groupe ',
      description: "Partez à l'aventure avec OuiCSport : des sorties et séjours sportifs en groupe encadrés par des professionnels. Randonnée, canoë, équitation, tennis, vélo… pour tous niveaux et en toute convivialité !"
    }
  },
  {
    path: '/CGU',
    name: 'CGU',
    component: Cgu,
    meta: {
      title: 'OuiCSport | Conditions Générales d’Utilisation (CGU)',
      description: "Consultez les conditions générales d'utilisation de OuiCSport pour comprendre vos droits et obligations en tant qu'utilisateur de notre plateforme de réservation d'activités sportives."
    }
  },
  {
    path: '/mentions-legales',
    name: 'mentionslegales',
    component: mentionslegales,
    meta: {
      title: 'OuiCSport | Mentions Légales',
      description: "Consultez les mentions légales de OuiCSport pour en savoir plus sur notre entreprise, nos conditions d'utilisation et nos engagements envers nos utilisateurs."
    }
  },
  {
    path: '/politique-de-confidentialite',
    name: 'politiqueConfidentialite',
    component: politiqueConfidentialite,
    meta: {
      title: 'OuiCSport | Politique de Confidentialité',
      description: "Découvrez comment OuiCSport collecte, utilise et protège vos données personnelles. Votre vie privée est notre priorité."
    }
  },
  {
    path: '/OffersList',
    name: 'OffersList',
    component: OffersListPage,
    meta: {
      title: 'OuiCSport | Nos Activités Sportives et Prochaines Sessions',
      description: "Explorez toutes les activités sportives proposées par OuiCSport et inscrivez-vous aux prochaines sessions : stages, séjours et sorties sportives encadrées pour tous les niveaux."
    }
  },
  {
    path: '/offer-details/:id',
    name: 'OfferDetailsPage',
    component: OfferDetailsPage,
    props: true,
    meta: {
      title: 'OuiCSport | Détails de l’Offre Sportive',
      description: "Découvrez tous les détails de nos offres sportives : activités, dates, lieux, tarifs, équipements inclus et modalités de réservation. OuiCSport vous accompagne pour une expérience sportive inoubliable."
    }
  },
  {
    path: '/offer-details-v2/:id',
    name: 'OfferDetailsPageV2',
    component: OfferDetailsPageV2,
    props: true,
    meta: {
      title: "OuiCSport |  Réservation",
      description: "Réservez une activité sportive en ligne avec OuiCSport. Sélectionnez vos dates, options, quantités et payez en toute sécurité par carte ou en plusieurs fois"
    }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: ContactPage,
    meta: {
      title: 'OuiCSport | Contactez-nous',
      description: "Vous avez une question, une suggestion ou un projet à organiser ? Contactez l’équipe OuiCSport via notre formulaire sécurisé. Nous vous répondrons dans les plus brefs délais."
    }
  },
  {
    path: '/gallery',
    name: 'Gallery',
    component: GaleryPage,
    meta: {
      title: 'OuiCSport | Galerie Photos des Activités Sportives',
      description: "Parcourez la galerie photos OuiCSport et revivez les meilleurs moments de nos sorties sportives. Ambiance conviviale, défis partagés et souvenirs mémorables garantis."
    }
  },
  {
    path: '/AdminGestionImagesOuicsport',
    name: 'AdminGestionImagesOuicsport',
    component: ImagesGestionPage,
  },
  {
    path: '/confirmation',
    name: 'ConfirmationPage',
    component: ConfirmationPage,
    props: true,
    meta: {
      title: 'OuiCSport | Confirmation de Réservation',
      description: '"Merci pour votre réservation chez OuiCSport ! Consultez le récapitulatif de votre activité sportive réservée, incluant les options choisies, la quantité et le montant total."'
    }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/',
  },
];

const router = createRouter({
  history: createWebHistory('/'),
  routes,
});

router.onError((error) => {
  console.error('Router error:', error);
  router.push('/');
});

router.afterEach(to => {
  if (to.meta?.title) {
    document.title = to.meta.title;
  }

  if (to.meta?.description) {
    let tag = document.querySelector('meta[name="description"]');
    if (!tag) {
      tag = document.createElement('meta');
      tag.setAttribute('name', 'description');
      document.head.appendChild(tag);
    }
    tag.setAttribute('content', to.meta.description);
  }
});

export default router;
